export var INTERACTION_MAP = {};
export var getInteraction = function (type) {
    return INTERACTION_MAP[type];
};
export var registerInteraction = function (type, ctor) {
    // 注册的时候，需要校验 type 重名，不区分大小写
    if (getInteraction(type)) {
        throw new Error("Interaction type '" + type + "' existed.");
    }
    // 存储到 map 中
    INTERACTION_MAP[type] = ctor;
};
//# sourceMappingURL=factory.js.map